import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  IonicPage,
  Keyboard,
  LoadingController,
  NavController,
  NavParams
} from 'ionic-angular';
import {LoginItem} from "../login/login-item";
import {LoginPage} from "../login/login";
import {RegisterPage} from "../register/register";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {Subscription} from "rxjs";

/**
 * Generated class for the PasswordForgottenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-password-forgotten',
  templateUrl: 'password-forgotten.html',
})
export class PasswordForgottenPage {
  @ViewChild(Content) public content: Content;

  item: LoginItem;
  loginPage: any = LoginPage;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiAuth: ApiAuthProvider,  private keyboard: Keyboard, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider) {
    this.item = new LoginItem();
  }

  keyboardDidShowCallback: Subscription;
  keyboardShowCallback: Subscription;
  keyboardHideCallback: Subscription;
  ionViewDidLoad() {
    var me = this;

    this.keyboardShowCallback = this.keyboard.willShow.subscribe(function() {
    }, () => {}, () => {
      me.content.scrollToBottom();
    });
    this.keyboardDidShowCallback = this.keyboard.didShow.subscribe(function() {
      setTimeout(() => {
        me.content.scrollToBottom();
      }, 50);
    });


    this.keyboardHideCallback = this.keyboard.willHide.subscribe(function() {
    });
  }


  ionViewDidLeave() {
    this.keyboardShowCallback.unsubscribe();
    this.keyboardHideCallback.unsubscribe();
    this.keyboardDidShowCallback.unsubscribe();
  }

  submitRequest() {
    var loader = this.loadingCtrl.create();
    loader.present();

    var me = this;

    this.apiAuth.passwordForgottenRequest(this.item.email).then((res:any) => {
      loader.dismissAll();

      var alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Password Forgotten Sent Title'),
        subTitle: this.contentTranslation.translateContent('Password Forgotten Sent Text'),
        buttons: [
          {
            text: this.contentTranslation.translateContent('OK').toUpperCase(),
          }],
        cssClass: 'password-forgotten-modal'
      });

      alert.present();
      alert.onDidDismiss(function() {
        me.navCtrl.push(LoginPage);
      })
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/password-forgotten/password-forgotten.ts